import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { connectNode } from '../../../utils/global'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Spinner from 'react-spinner-material'

import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'

class WorksheetList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      error: '',
      dataItems: [],
      dataSGitems: [],
      dataRCitems: [],
      main_category_list: [],
      categoryByMain: {},
      worksheetByCategory: {},
      worksheetAssigned: [],
      assignedWorksheetIds: new Set(),
      assignedCategoryIds: new Set(),
    }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = async () => {
    this.setState({ loading: true, error: '' })

    try {
      const result = await axios({
        method: 'post',
        url: connectNode + 'admin/worksheets/get_worksheet_w_main_category',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
        },
        data: { pid: this.props.authReducer.uid },
      })

      const worksheet_list = result?.data?.[0]?.value || []
      const main_category_list = result?.data?.[1]?.value || []
      const category_list = result?.data?.[2]?.value || []
      const worksheet_asigned = result?.data?.[3]?.value || []

      const categoryByMain = category_list.reduce((acc, cat) => {
        const mainCategoryId = cat.main_category_id
        if (!acc[mainCategoryId]) {
          acc[mainCategoryId] = []
        }
        acc[mainCategoryId].push(cat)
        return acc
      }, {})

      const worksheetByCategory = worksheet_list.reduce((acc, worksheet) => {
        const categoryId = worksheet.category_id
        if (!acc[categoryId]) {
          acc[categoryId] = []
        }
        acc[categoryId].push(worksheet)
        return acc
      }, {})

      // assigned worksheet ids from worksheet_asigned
      const assignedWorksheetIds = new Set(
        worksheet_asigned.map((item) => Number(item.worksheet_id))
      )

      // assigned category ids based on worksheet_list
      const assignedCategoryIds = new Set(
        worksheet_list
          .filter((worksheet) => assignedWorksheetIds.has(Number(worksheet.id)))
          .map((worksheet) => Number(worksheet.category_id))
      )

      this.setState({
        main_category_list,
        categoryByMain,
        worksheetByCategory,
        worksheetAssigned: worksheet_asigned,
        assignedWorksheetIds,
        assignedCategoryIds,
        loading: false,
      })
    } catch (error) {
      console.error('Failed to load worksheet data:', error)
      this.setState({
        loading: false,
        error: 'Unable to load worksheet data.',
      })
    }
  }

  convertDateFormat = (date) => {
    if (!date) return ''

    const buff1 = date.split(' ')
    const buff2 = buff1[0].split('-')

    if (buff2.length < 3) return date

    return `${buff2[1]}/${buff2[2]}/${buff2[0]}${buff1[1] ? ', ' + buff1[1] : ''}`
  }

  renderWorksheetTable = (worksheets = []) => {
    const { assignedWorksheetIds } = this.state

    if (!worksheets.length) {
      return <div>No worksheets found.</div>
    }

    return (
      <table className="table_data1">
        <tbody>
          {worksheets.map((worksheet) => {
            const isAssigned = assignedWorksheetIds.has(Number(worksheet.id))

            return (
              <tr
                key={worksheet.id}
                style={{
                  //backgroundColor: isAssigned ? '#f9feff' : '',
                  fontWeight: isAssigned ? 'bold' : 'normal',
                  color: isAssigned ? '#007e9f' : 'inherit',
                  //border: isAssigned ? '#00bae9' : 'inherit',
                }}
              >
                <td>
                  {worksheet.name}
                  {isAssigned && (
                    <span style={{ marginLeft: '8px', color: '#00bae9' }}>
                      (Assigned)
                    </span>
                  )}
                </td>
                <td>
                  <a href={`/member/worksheets/worksheet_pdf/${worksheet.id}`}>
                    Download
                  </a>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  render() {
    const {
      loading,
      error,
      main_category_list,
      categoryByMain,
      worksheetByCategory,
      dataSGitems,
      assignedCategoryIds,
    } = this.state

    return (
      <>
        <div className="patient_dashboard box_border4 patient_worksheets">
          <div className="row">
            <div className="small-12 columns headerPage1">
              Worksheets
            </div>
          </div>

          {loading && (
            <div className="loading1">
              <Spinner color="#bbbbbb" radius={50} />
            </div>
          )}

          {error && (
            <div className="warning_msg3">
              <div className="txt_warning_msg1">{error}</div>
            </div>
          )}

          {!loading &&
            main_category_list.map((main) => (
              <div className="row bottom_space1" key={main.id}>
                <div className="small-12 columns">
                  <p className="head2_1 bold">{main.main_category_name}</p>

                  {(categoryByMain[main.id] || []).map((cat) => {
                    const categoryId = cat.id || cat.category_id
                    const worksheets = worksheetByCategory[categoryId] || []
                    const isCategoryAssigned = assignedCategoryIds.has(Number(categoryId))

                    return (
                      <Accordion
                        key={categoryId}
                        style={{
                          //border: isCategoryAssigned ? '1px solid #87bbc8' : '',
                          backgroundColor: isCategoryAssigned ? '#ecf8fb' : '',
                          color: isCategoryAssigned ? '#007e9f' : 'inherit',
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography style={{ fontWeight: isCategoryAssigned ? 'bold' : 'normal' }}>
                            {cat.category_name}
                            { /*isCategoryAssigned ? ' (Assigned)' : ''*/}
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          {this.renderWorksheetTable(worksheets)}
                        </AccordionDetails>
                      </Accordion>
                    )
                  })}
                </div>
              </div>
            ))}
        </div>

        <div className="patient_dashboard box_border4 top_space1">
          <div className="row">
            <div className="small-12 columns headerPage1">
              Self-Guided Program
            </div>
          </div>

          <div className="row">
            <div className="small-12 columns">
              {typeof this.props.locationReducer.txt_message !== 'undefined' &&
                this.props.locationReducer.txt_message !== '' && (
                  <div className="warning_msg3">
                    <div className="float_left1">
                      <CheckCircleOutlineIcon />
                    </div>
                    <div className="txt_warning_msg1">
                      {this.props.locationReducer.txt_message}
                    </div>
                  </div>
                )}

              <div>
                <table className="table_data1">
                  <thead className="table_head">
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Link</th>
                      <th>Detail</th>
                      <th>Assigned By</th>
                      <th>Assigned Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" className="loading1">
                          <Spinner color="#bbbbbb" radius={50} />
                        </td>
                      </tr>
                    ) : dataSGitems.length === 0 ? (
                      <tr>
                        <td colSpan="6">No self-guided items be assigned.</td>
                      </tr>
                    ) : (
                      dataSGitems.map((item) => (
                        <tr key={item.id}>
                          <td>{item.sg_id}</td>
                          <td>{item.name}</td>
                          <td>
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Link
                            </a>
                          </td>
                          <td>
                            <a href={`/member/worksheets/self_guide_detail/${item.sg_id}`}>
                              Detail
                            </a>
                          </td>
                          <td>{item.clinicians || item.admins}</td>
                          <td>{this.convertDateFormat(item.created_time)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(WorksheetList)
